import React, { useEffect, useRef, useState } from "react";
import { useI18next } from "../../../../plugins/gatsby-plugin-ap-i18next/src/useI18next";
import { useFormikContext } from "formik";
import { navigate } from "gatsby";

import Arrow from "../../../assets/images/svg/expand-button.svg";
import {
    applyButton,
    clearButton,
    container,
    filtersBox,
    filtersExpandBox,
    generate,
    generateButton,
    mobileButtons,
    mobileHeader,
    buttonMobileHeader,
    noMobile,
    open,
    openButton,
    pressSpace,
    medium,
    priceList,
    price,
    productList,
    selectList,
    selects,
    leftSide,
    leftSideScroll,
    leftSideCollapsed,
    rightSide,
    rightSideExpanded,
    selectInput,
    titleStyles,
    titleStylesTop,
    titleBig,
    collapseFiltersButton,
    collapseFiltersButtonMenu,
    collapseFiltersHamburger,
    generateTip,
    arrowTop,
    clickTip,
    generateButtonsBar,
    saveActionButton,
    restoreActionButton,
    tryOnButton,
    virtualTryOnContainer,
    virtualTryOnContainerImage,
    productCardMinimal,
    buttonContent,
    productsViewMobileContainer,
    imageSliderWrapper,
    checkAvailabilityButton,
    checkAvailabilityButtonInner,
    checkAvailabilityText,
    checkAvailabilityIcon,
    uploadPhotoContainer,
    guideHelpRow,
    guideHelpBtn,
    tourHelpButton,
    mobileNavMenuButton,
    mobileNavMenu,
    mobileNavMenuOpen,
    productListTryOnView,
    scrollTopButton,
    scrollTopButtonVisible,
    scrollTopIcon
} from "./generator-draw-fields.module.scss";
import FilterIcon from "../../../assets/images/svg/filters.svg";
import { breakpoints } from "../../../config/breakpoints";
import { fieldsAvailableToClear, priceFilters, selectFiltersConfigs } from "../config";
import {
    EGeneratorFilterKeys,
    IGeneratorFormValues,
    IGeneratorProductsSetPayload,
    TBlockedProduct,
    TGeneratorFilters,
} from "../../../models/generator.model";
import { IProduct } from "../../../models/product.model";
import { capitalizeFirstLetter } from "../../../utils/capitalize-first-letter";
import {
    selectGeneratorProducts,
    selectGeneratorProductsStatus,
} from "../../../redux/generator-products/generator-products.selectors";
import useMediaQuery from "../../../hooks/use-media-query";
import useUser from "../../../apps/auth/hooks/use-user";

import Select from "../../../components/atoms/form/select";
import ProductCard from "../molecules/product-card";
import Button from "../../../components/atoms/button";
import SwitchInput from "../../../components/atoms/form/switch-input";
import ButtonClose from "../../../components/atoms/button-close";
import ButtonWand from "../../../components/molecules/button-wand";
import ImageSlider from "../../../components/organisms/image-slider";
import { Helmet } from "react-helmet";
import ButtonIcon from "../../../components/molecules/button-icon";
import { useDispatch, useSelector } from "react-redux";
import { createVirtualTryOnAction } from "../../../redux/virtual-tryon/virtual-tryon.actions";
import { IVirtualTryOn } from "../../../models/virtualtryon.model";
import { selectVirtualTryOn } from "../../../redux/virtual-tryon/virtual-tryon.selectors";
import Loader from "../../../components/atoms/loader";
import ImageUploader from "../../../components/molecules/image-uploader";
import { uploadFileToApi } from "../../../services/fileupload-services";
import ImageSliderSimple from "../../../components/organisms/image-slider-simple";
import { postProductStatistic } from '../../../services/product-services';
import { useModalContext } from "../../../contexts/modal.context";
import { EModal } from "../../../models/modal.model";
import GeneratorTour from "./generator-tour";
import { getAbsolutePath } from "../../utility/routes.utility";
import useFillSurvey from "../../survey/hooks/use-fill-survey";
import { restorePreviousGeneratorProductsAction } from "../../../redux/generator-products/generator-products.actions";

const GENERATOR_TOUR_STORAGE_KEY = "fashionfairy-generator-tour-completed";

interface IGeneratorDrawFields {
    className?: string;
    filters: TGeneratorFilters;
    products: IProduct[];
    onSpaceKeydown?(): void;
    onSave?(): void;
    counterClick?: number;
}

const GeneratorDrawFields: React.FC<IGeneratorDrawFields> = ({
    className = "",
    filters,
    products,
    onSpaceKeydown,
    onSave,
    counterClick,
}) => {
    const { t } = useI18next();
    const formik = useFormikContext<IGeneratorFormValues>();
    const isTablet = useMediaQuery(breakpoints.tablet);
    const [isOpen, setIsOpen] = useState(false);
    const [isFiltersCollapsed, setIsFiltersCollapsed] = useState(false);
    const surveyPopup = false;
    const [tryOnView, setTryOnView] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isUploadPhotoButton, setIsUploadPhotoButton] = useState(false);
    const [isScrollTopVisible, setIsScrollTopVisible] = useState(false);
    const surveyPopupRef = useRef(false);
    const { sessionId, sessionGuid, items }: IGeneratorProductsSetPayload = useSelector(selectGeneratorProducts);
    const previousProducts = useSelector(selectGeneratorProducts).previous;
    const virtualTryOnViewer: IVirtualTryOn = useSelector(selectVirtualTryOn);
    const isFirstRender = useRef(true);
    const [uploadFile, setUploadFile] = useState<File | null>(null);
    const [virtalTryOnList, setVirtualTryOnList] = useState<string[]>([]);
    const [customIndex, setCurrentIndex] = useState(0);
    const [isTourOpen, setIsTourOpen] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const [loadingVirtualTryOnListTexts] = useState([
        "Czarodziejska przymiarka w 3…2…1…",
        "Magiczna przemiana w toku ✨",
        "Znikają wątpliwości, pojawia się look",
        "Odliczaj do efektu wow",
        "Magia trwa — bądź gotowa",
        "Magiczne zaklęcie już działa…",
        "Właśnie zakładam na Ciebie nowy look",
        "Zaraz zobaczysz, jak nowy outfit lśni na Tobie ✨",
        "Magia działa… ubrania właśnie się zakładają 🪄"
    ]);
    //const [showSpecialTryOn, setShowSpecialTryOn] = useState(false);

    const { data, isLoggedIn } = useUser();
    const { unansweredPages } = useFillSurvey();
    const dispatch = useDispatch();
    const hasCompletedSurvey = Array.isArray(unansweredPages) && unansweredPages.length === 0;
    const hasPreviousProducts = !!previousProducts?.items?.length;
    const canRestorePrevious = isLoggedIn ? hasCompletedSurvey && hasPreviousProducts : hasPreviousProducts;
    const accountLinkHref = isLoggedIn ? getAbsolutePath("ACCOUNT_DASHBOARD") : "/auth/";
    const accountLinkLabel = isLoggedIn ? "Twoje konto" : "Zaloguj się";
    const mobileNavItems = [
        { label: "O Mnie", to: "/o-nas/" },
        { label: "Blog", to: "/blog/" },
        { label: "Kontakt", to: "/kontakt/" },
        { label: accountLinkLabel, to: accountLinkHref },
    ];

    const { addModal } = useModalContext();

    const handleOpenTour = () => setIsTourOpen(true);
    const handleCloseTour = () => {
        setIsTourOpen(false);
        if (typeof window !== "undefined") {
            window.localStorage.setItem(GENERATOR_TOUR_STORAGE_KEY, "true");
        }
    };

    const handleOpenPhotoGuide = () => {
        addModal({
            key: EModal.PHOTO_GUIDE,
        });
    };

    const handleLoginRequired = () => {
        addModal({
            key: EModal.CONFIRMATION,
            props: {
                title: "Zaloguj się, aby korzystać z tej funkcji",
                content:
                    "Kłódka, ulubione produkty, cofanie i zapisywanie stylizacji są dostępne po zalogowaniu.",
                confirmText: "Zaloguj się",
                cancelText: "Zostań tutaj",
                onConfirm: () => navigate("/auth/"),
            },
        });
    };


    useEffect(() => {
        if (typeof window === "undefined") return;
        if (window.localStorage.getItem(GENERATOR_TOUR_STORAGE_KEY)) return;

        const timeoutId = window.setTimeout(() => setIsTourOpen(true), 700);
        return () => window.clearTimeout(timeoutId);
    }, []);
    const handleOpenFilters = () => {
        setIsOpen(true);
    };

    const handleCloseFilters = () => {
        setIsOpen(false);
    };

    const handleMobileNavigate = (to: string) => {
        setIsMobileMenuOpen(false);
        navigate(to);
    };

    const handleToggleFiltersCollapse = () => {
        setIsFiltersCollapsed((prev) => !prev);
    };

    const handleSave = () => {
        if (!isLoggedIn) {
            handleLoginRequired();
            return;
        }

        if (typeof onSave !== "function") return;
        onSave();
    };

    const handleRestorePrevious = () => {
        if (!isLoggedIn) {
            handleLoginRequired();
            return;
        }

        dispatch(restorePreviousGeneratorProductsAction());
    };

    const handleClear = () => {
        fieldsAvailableToClear.forEach((fieldKey) => {
            const clearedValue = Array.isArray(formik.values[fieldKey]) ? [] : "";
            formik.setFieldValue(fieldKey, clearedValue);
        });
    };

    const handleLockProduct = (product: IProduct) => () => {
        if (!isLoggedIn) {
            handleLoginRequired();
            return;
        }

        const lockedProducts = formik.values.blockedProducts;
        const lockedProductIds = lockedProducts.map((product) => product.productId);
        let newLockedProducts: TBlockedProduct[];
        if (lockedProductIds.includes(product.productId)) {
            newLockedProducts = lockedProducts.filter(
                (lockedProduct) => lockedProduct.productId !== product.productId
            );
        } else {
            newLockedProducts = [
                ...lockedProducts,
                { productId: product.productId, categoryGroup: product.categoryGroup },
            ];
        }
        formik.setFieldValue("blockedProducts", newLockedProducts, false);
    };

    const handleTryOnClick = () => {
        console.log("handleTryOnClick called: ", sessionGuid);
        setIsLoading(true);
        dispatch(
            createVirtualTryOnAction({
                guid: sessionGuid
            })
        );
    }

    const handleTryOnAndUploadClick = async () => {
        console.log("handleTryOnAndUploadClick called: ", sessionGuid);
        setIsLoading(true);

        var uploadResponse = await uploadFileToApi(uploadFile);

        setUploadFile(null);
        setIsUploadPhotoButton(false);
        dispatch(
            createVirtualTryOnAction({
                guid: sessionGuid
            })
        );
    }
    const handleShowProducts = () => {
        console.log("handleShowProducts called: ", sessionGuid);
        setTryOnView(false);
    }

    const onUploadPhoto = (file: File) => {
        console.log("onUploadPhoto called: ", file);
        setUploadFile(file);
        setIsUploadPhotoButton(true);
    }

    const productClickCustom = (product: IProduct) => {
        console.log("productClickCustom called: ", product);
        var index = products.findIndex(p => p.productId === product.productId);
        console.log("productClickCustom called: ", index);
        setCurrentIndex(index);
    }

    const handleCheckAvailability = () => {
        if (products.length > 0 && customIndex !== undefined && products[customIndex]) {
            const product = products[customIndex];
            postProductStatistic(product);
            const url = product.affiliateUrl || product.url;
            if (url) {
                window.open(url, '_blank');
            }
        }
    }

    const handleScrollTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    useEffect(() => {
        if (isTablet) {
            setIsScrollTopVisible(false);
            return;
        }

        const handleScroll = () => {
            setIsScrollTopVisible(window.scrollY > 20);
        };

        handleScroll();
        window.addEventListener("scroll", handleScroll, { passive: true });

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [isTablet]);

    useEffect(() => {
        const handleKeydown = (event: KeyboardEvent) => {
            if (event.code !== "Space") return;
            if (surveyPopupRef.current) return;
            event.preventDefault();
            if (typeof onSpaceKeydown !== "function") return;
            onSpaceKeydown();
        };
        document.addEventListener("keydown", handleKeydown);

        if (typeof window !== "undefined" && typeof window.gtag === "function") {
            window.gtag('event', 'conversion', { 'send_to': 'AW-985215664/GkuICPjm3bcaELDl5NUD' });
        }

        return () => {
            document.removeEventListener("keydown", handleKeydown);
        };
    }, []);
    useEffect(() => {
        setTryOnView(false);
    }, [products])

    // useEffect(() => {
    //     setShowSpecialTryOn(data
    //         && (data.userId == 11 || data.userId == 12 || data.userId == 17 || data.userId == 18 || data.userId == 20 || data.userId == 21 || data.userId == 23));
    // }, [data])
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return; // NIE wykonuj kodu przy pierwszym renderze
        }
        if (virtualTryOnViewer && virtualTryOnViewer.imageUrl) {
            setIsLoading(false);
            setTryOnView(true);
            const list = [virtualTryOnViewer.imageUrl1];
            if (virtualTryOnViewer.imageUrl2) {
                list.push(virtualTryOnViewer.imageUrl2);
            }
            setVirtualTryOnList(list);
        }
    }, [virtualTryOnViewer])
    return (
        <>
            <GeneratorTour isOpen={isTourOpen} onClose={handleCloseTour} />
            {isLoading && <Loader position="fixed" texts={loadingVirtualTryOnListTexts} />}
            <Helmet>
                <script>
                    {`
                  gtag('event', 'conversion', {'send_to': 'AW-985215664/GkuICPjm3bcaELDl5NUD'});
                `}
                </script>
            </Helmet>
            <div style={{ display: "none" }}>!!</div>
            <div className={`${container} ${className}`}>
                <div
                    className={`${leftSide} ${!isTablet && isFiltersCollapsed ? leftSideCollapsed : ""}`}
                    data-generator-tour="filters"
                >
                    <div className={leftSideScroll}>
                        <div className={filtersExpandBox}>
                            <button type="button" onClick={handleOpenFilters} className={openButton}>
                                <FilterIcon /> {t("generator.button.filters")}
                            </button>
                            <button
                                type="button"
                                className={tourHelpButton}
                                onClick={handleOpenTour}
                                data-generator-tour="help"
                                aria-label="Otwórz samouczek generatora"
                                title="Samouczek"
                            >
                                ?
                            </button>
                            <button
                                type="button"
                                className={mobileNavMenuButton}
                                aria-label={isMobileMenuOpen ? "Zamknij menu" : "Otwórz menu"}
                                aria-expanded={isMobileMenuOpen}
                                onClick={() => setIsMobileMenuOpen((isOpen) => !isOpen)}
                            >
                                <span />
                                <span />
                                <span />
                            </button>
                            <div className={`${mobileNavMenu} ${isMobileMenuOpen ? mobileNavMenuOpen : ""}`}>
                                {mobileNavItems.map((item) => (
                                    <button
                                        key={item.to}
                                        type="button"
                                        onClick={() => handleMobileNavigate(item.to)}
                                    >
                                        {item.label}
                                    </button>
                                ))}
                            </div>
                        </div>
                        <div className={`${filtersBox} ${isOpen ? open : ""}`}>
                        <div className={mobileHeader}>
                            <p>{t("generator.filters.title")}</p>
                            <ButtonClose className={buttonMobileHeader} onClick={handleCloseFilters} />
                        </div>
                        <div className={titleStyles}>
                            <div className={titleStylesTop}>
                                <div className={titleBig}>
                                    Stwórz<br />stylówkę
                                </div>
                                {!isTablet && !isFiltersCollapsed && (
                                    <button
                                        type="button"
                                        className={tourHelpButton}
                                        onClick={handleOpenTour}
                                        data-generator-tour="help"
                                        aria-label="Otwórz samouczek generatora"
                                        title="Samouczek"
                                    >
                                        ?
                                    </button>
                                )}
                                {!isTablet && (
                                    <button
                                        type="button"
                                        className={`${collapseFiltersButton} ${
                                            isFiltersCollapsed ? collapseFiltersButtonMenu : ""
                                        }`}
                                        onClick={handleToggleFiltersCollapse}
                                        aria-label={
                                            isFiltersCollapsed
                                                ? "Rozwiń panel filtrów"
                                                : "Zwiń panel filtrów"
                                        }
                                    >
                                        {isFiltersCollapsed ? (
                                            <span
                                                className={collapseFiltersHamburger}
                                                aria-hidden
                                            >
                                                <span />
                                                <span />
                                                <span />
                                            </span>
                                        ) : (
                                            "×"
                                        )}
                                    </button>
                                )}
                            </div>
                        </div>
                        <div className={selects}>
                            {selectFiltersConfigs.map((config) => {
                                const { isMultiselect, selectClassName, filterKey } = config;
                                return (
                                    <Select
                                        key={filterKey}
                                        className={`${selectClassName} ${selectInput}`}
                                        options={filters[filterKey]}
                                        name={filterKey}
                                        label={t(`generator.form.label.${filterKey}`)}
                                        placeholder={t(`generator.form.placeholder.${filterKey}`)}
                                        isMultiselect={isMultiselect}
                                        showCounter={isMultiselect}
                                        colorTheme="light"
                                        styleTheme="compact"
                                        selectText={isMultiselect ? "label" : "option"}
                                        listClassName={selectList}
                                        layout="generatorPanel"
                                        generatorPanelVariant={
                                            filterKey === EGeneratorFilterKeys.colors
                                                ? "colors"
                                                : filterKey === EGeneratorFilterKeys.patterns
                                                ? "patterns"
                                                : "default"
                                        }
                                    />
                                );
                            })}
                            <div className={priceList}>
                                {priceFilters.map((filterKey) => (
                                    <Select
                                        key={filterKey}
                                        className={`${medium} ${selectInput}`}
                                        options={filters[filterKey]}
                                        name={filterKey}
                                        label={t(`generator.form.label.${filterKey}`)}
                                        placeholder={t(`generator.form.placeholder.${filterKey}`)}
                                        colorTheme="light"
                                        styleTheme="compact"
                                        selectText="option"
                                        listClassName={selectList}
                                        layout="generatorPanel"
                                        generatorPanelVariant="budget"
                                    />
                                ))}
                            </div>
                        </div>
                        <div className={mobileButtons}>
                            <Button
                                color="primary"
                                type="outlined"
                                className={clearButton}
                                htmlType="button"
                                onClick={handleClear}
                            >
                                {t("generator.button.clear")}
                            </Button>
                            <Button
                                color="beige"
                                type="filled"
                                className={applyButton}
                                htmlType="submit"
                                onClick={handleCloseFilters}
                            >
                                {t("generator.button.apply")}
                            </Button>
                        </div>
                        </div>
                    </div>

                </div>
                <div className={`${rightSide} ${!isTablet && isFiltersCollapsed ? rightSideExpanded : ""}`}>
                    {!tryOnView && <>
                        {!isTablet && <div className={productList}
                        data-generator-tour="products"
                        style={{ gridTemplateColumns: `repeat(${products.length}, minmax(0, 1fr))` }}
                        >
                            {products.map((product) => {
                                const categoryPriceKey = `price${capitalizeFirstLetter(
                                    product.categoryGroup
                                )}` as keyof TGeneratorFilters;
                                return (
                                    <ProductCard
                                        showInputs={true}
                                        isTablet={isTablet}
                                        key={product.productId}
                                        product={product}
                                        productLength={products.length}
                                        onPadlockClick={handleLockProduct(product)}
                                        isLocked={getIsLocked(formik.values.blockedProducts, product)}
                                        classNameProduct={price}
                                        nameProduct={categoryPriceKey}
                                        optionsProduct={filters[categoryPriceKey]}
                                        labelProduct={t(`generator.form.label.${categoryPriceKey}`)}
                                        onLoginRequired={handleLoginRequired}
                                    />
                                );
                            })}
                        </div>}
                        {isTablet && <div className={productsViewMobileContainer} data-generator-tour="products">
                            <div className={imageSliderWrapper}>
                                <ImageSlider
                                    products={products}
                                    customIndex={customIndex}
                                    onSlideUp={onSpaceKeydown}
                                    surveyPopup={surveyPopup}
                                    isLoggedIn={isLoggedIn}
                                    onLoginRequired={handleLoginRequired}
                                />
                                {!tryOnView && (
                                    <div className={checkAvailabilityButton}>
                                        <button type="button" onClick={handleCheckAvailability} className={checkAvailabilityButtonInner}>
                                            <div className={checkAvailabilityText}>
                                                <span>Sprawdź</span>
                                                <span>dostępność</span>
                                            </div>
                                            <svg className={checkAvailabilityIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="10" cy="10" r="7" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                                <path d="m16 16 4 4" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </button>
                                    </div>
                                )}
                            </div>
                            <div className={productList}>
                                {products.map((product) => {
                                    const categoryPriceKey = `price${capitalizeFirstLetter(
                                        product.categoryGroup
                                    )}` as keyof TGeneratorFilters;
                                    return (
                                        <ProductCard
                                            isMinimal={true}
                                            className={productCardMinimal}
                                            classNameButtonContent={buttonContent}
                                            showInputs={false}
                                            isTablet={isTablet}
                                            key={product.productId}
                                            product={product}
                                            productLength={products.length}
                                            classNameProduct={price}
                                            nameProduct={categoryPriceKey}
                                            optionsProduct={filters[categoryPriceKey]}
                                            productClickCustomFn={productClickCustom}
                                            labelProduct={t(`generator.form.label.${categoryPriceKey}`)}
                                            onLoginRequired={handleLoginRequired}
                                        />
                                    );
                                })}
                            </div>
                        </div>}
                    </>}
                    {tryOnView && <div className={virtualTryOnContainer}>
                        {virtualTryOnViewer && virtualTryOnViewer.status == 0 && <>
                            {!isTablet && <h2>Stylówka na Tobie</h2>}
                            <div className={virtualTryOnContainerImage}>
                                {!isTablet && virtualTryOnViewer && virtualTryOnViewer.imageUrl && <img src={virtualTryOnViewer.imageUrl}></img>}
                                {isTablet && virtualTryOnViewer && virtualTryOnViewer.imageUrl && <div style={{ flex: '85%' }}><ImageSliderSimple products={virtalTryOnList} onSlideUp={onSpaceKeydown} surveyPopup={surveyPopup} isLoggedIn={isLoggedIn} /></div>}
                                <div className={`${productList} ${productListTryOnView}`}>
                                    {products.map((product) => {
                                        const categoryPriceKey = `price${capitalizeFirstLetter(
                                            product.categoryGroup
                                        )}` as keyof TGeneratorFilters;
                                        return (
                                            <ProductCard
                                                isMinimal={true}
                                                className={productCardMinimal}
                                                classNameButtonContent={buttonContent}
                                                showInputs={false}
                                                isTablet={isTablet}
                                                key={product.productId}
                                                product={product}
                                                productLength={products.length}
                                                classNameProduct={price}
                                                nameProduct={categoryPriceKey}
                                                optionsProduct={filters[categoryPriceKey]}
                                                labelProduct={t(`generator.form.label.${categoryPriceKey}`)}
                                                onLoginRequired={handleLoginRequired}
                                            />
                                        );
                                    })}
                                </div>
                            </div>
                        </>}
                        {virtualTryOnViewer && virtualTryOnViewer.status == -1 && <>
                            <div className={uploadPhotoContainer}>
                                <ImageUploader onUploadPhoto={onUploadPhoto} isSpecial={true}></ImageUploader>
                            </div>

                            <div className={guideHelpRow}>
                                <button className={guideHelpBtn} type="button" onClick={handleOpenPhotoGuide}>
                                    <span className="qmark">?</span>
                                    Jak właściwie wybrać zdjęcie?
                                </button>
                            </div>
                        </>}
                    </div>}
                    <div className={generate}>
                        {/* {isTablet && !tryOnView && <div className={clickTip}><p>Kliknij w obrazek aby obejrzeć ubranie</p></div>} */}
                        {!tryOnView && <div className={generateTip}>
                            <Arrow className={arrowTop} />
                            <p>Przesuń palcem w góre aby wyczarować dalej...</p>
                        </div>}
                        {!surveyPopup &&
                            <div className={generateButtonsBar} data-generator-tour="actions">
                                <ButtonWand withLink={false} htmlType="submit" className={generateButton} text={(isTablet ? "Wyczaruj" : t("generator.button.generate"))}>
                                </ButtonWand>
                                {<>
                                    {canRestorePrevious && !tryOnView && (
                                        <ButtonIcon
                                            withLink={false}
                                            onClick={handleRestorePrevious}
                                            htmlType="button"
                                            className={restoreActionButton}
                                            text="Cofnij"
                                        />
                                    )}
                                    {!tryOnView && typeof onSave === "function" && (
                                        <ButtonIcon
                                            withLink={false}
                                            onClick={handleSave}
                                            htmlType="button"
                                            className={saveActionButton}
                                            text="Zapisz styl"
                                        />
                                    )}
                                    {/* {isLoggedIn && tryOnView && !isUploadPhotoButton && <ButtonIcon withLink={false} onClick={handleShowProducts} htmlType="button" className={tryOnButton} text={"Pokaż ubrania"}>
                                    </ButtonIcon>} */}
                                </>}
                            </div>
                        }
                        {/* <p className={pressSpace}>{t("generator.press.space")}</p> */}
                    </div>
                    {!isTablet && (
                        <button
                            type="button"
                            className={`${scrollTopButton} ${isScrollTopVisible ? scrollTopButtonVisible : ""}`}
                            onClick={handleScrollTop}
                            aria-label="Przewiń do góry"
                        >
                            <span className={scrollTopIcon} aria-hidden>
                                ↑
                            </span>
                        </button>
                    )}
                </div>
            </div>
        </>
    );
};

function getIsLocked(blockedProducts: TBlockedProduct[], product: IProduct) {
    return blockedProducts.map((product) => product.productId).includes(product.productId);
}

export default GeneratorDrawFields;
